'use strict';

export function init () {
    const InfiniteScroll = require('infinite-scroll');

    const wrapperSelector = '.js-paginator-wrapper';
    const nextSelector = '.js-next-pagination';
    const holderSelector = '.js-paginator-holder';

    const elements = document.querySelectorAll(wrapperSelector);

    elements.forEach(wrapper => {
        const paginationHolder = wrapper.querySelector(holderSelector);
        const paginationNextLink = wrapper.querySelector(nextSelector);

        const perPage = paginationHolder.dataset.perpage;
        const nextPage = paginationHolder.dataset.nextlink;

        const InfScroll = new InfiniteScroll(paginationHolder, {
            path: function setPath() {

                const link = nextPage;
                const current = (this.loadCount + 1) * perPage;
                return link.replace(/(start=)[^&]+/, '') + 'start=' + current;

            },
            append: paginationHolder.dataset.items,
            button: nextSelector,
            checkLastPage: true,
            scrollThreshold: false,
            debug: false,
            history: false,
            status: '.js-unit-loading',
        });

        wrapper.classList.add('infiniscroll-initialised');

        InfScroll.on('append', function onAppend(response/*, path, items */) {
            if (response.querySelector(nextSelector)) {
                paginationNextLink.removeAttribute('style');
            } else {
                paginationNextLink.setAttribute('style', 'display:none !important');
            }
        });

        InfScroll.on('request', function onRequest(/* response, path */) {
            paginationNextLink.setAttribute('style', 'display:none !important');
        });
    });
}
